import React, { Component } from "react";
import Image from "../../../base/features/micro/Image";
import createLink from "../../../base/utils/createLink";
import OpenApp from "react-open-app";

class ShopContacts extends Component {
  render() {
    return (
      <OpenApp
        href={createLink(this.props.contact)}
        android={createLink(this.props.contact, "android")}
        ios={createLink(this.props.contact)}
      >
        <div className="row mx-0 px-0 py-2 border-bottom">
          <div className="col-auto p-3 align-self-center">
            <Image
              imageUri={
                this.props.contact.type.icon &&
                this.props.contact.type.icon.icon_128
              }
              imgClassName={"img-cover"}
              imageHeight={"35"}
              imageWidth={"35"}
              extraClassName={"rounded-circle bg-color-main p-2"}
            />
          </div>
          <div className="col-9 px-0 align-self-center">
            <p className="mb-0" style={{ overflowWrap: "anywhere" }}>
              {this.props.contact.value}
            </p>
          </div>
        </div>
      </OpenApp>
    );
  }
}

export default ShopContacts;
